import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useUser } from "../context/UserContext";
import Topbar from "../component/Topbar";
import Sidebar from "../component/Sidebar";
import Footer from "../component/Footer";
import BonusCalculator from "../component/bonus/BonusCalculator";
import HowBonus from "../component/bonus/HowBonus";
import HowItWorks from "../component/bonus/HowItWorks";
import BonusFaq from "../component/bonus/BonusFaq";
import EnrollModal from "../component/bonus/EnrollModal";

export default function BonusPrograms() {
  const navigate = useNavigate();
  const [showClaimModal, setShowClaimModal] = useState(false);

  const { userData: contextUserData } = useUser();
  const cookieUserData = JSON.parse(Cookies.get("userdata") || "{}");
  const userData = contextUserData || cookieUserData;

  const depositBonusPer = userData?.deposit_bonus_per ?? 30;
  const maxDepositBonus = userData?.max_deposit_bonus ?? 2100;
  const lotsPer100 = userData?.lots_per_100 ?? 2.5;

  const pillBadges = [
    { icon: "bx bx-check-shield", label: "Tradable Bonus" },
    { icon: "bx bx-transfer-alt", label: "Converts to Real Balance" },
    { icon: "bx bx-wallet", label: "100% Withdrawable" },
    { icon: "bx bx-rocket", label: "Boost Your Trading" },
  ];

  return (
    <div id="layout-wrapper">
      <Topbar />
      <Sidebar />

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid mb-4">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <div>
                    <h2 className="fw-700 mb-sm-0">Bonus Programs</h2>
                  </div>
                  <div className="page-title-right d-flex align-items-center gap-2">
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light d-flex align-items-center"
                      onClick={() => navigate("/bonus_history")}
                    >
                      <i className="bx bx-history me-2 fs-5"></i> Bonus History
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light d-flex align-items-center"
                      onClick={() => navigate("/claim_history")}
                    >
                      <i className="bx bx-receipt me-2 fs-5"></i> Claim History
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="position-relative overflow-hidden mb-4 card-animate bg-primary-subtle rounded-4" >
              <div className="p-4 pb-md-4">
                <div className="mb-3">
                  <span
                    className="d-inline-flex align-items-center text-muted gap-1 px-3 py-1 font-size-11 fw-semibold text-uppercase shadow-sm"
                    style={{
                      backgroundColor: "var(--bs-card-bg)",
                      border: "1px solid var(--bs-primary-border-subtle)",
                      borderRadius: "var(--bs-border-radius-pill)",
                      letterSpacing: "0.5px",
                    }}
                  >
                    <span>Limited Time Offer</span>
                  </span>
                </div>

                <h1
                  className="fw-bold mb-2 "
                  style={{
                    fontSize: "calc(1.2rem + 1vw)",
                    letterSpacing: "-0.5px",
                  }}
                >
                  Get Benifited of Bonus
                </h1>

                <p
                  className="mb-4 text-muted"
                  style={{
                    fontSize: "14px",
                    maxWidth: "600px",
                    lineHeight: "1.6",
                  }}
                >
                  Deposit, trade, and unlock your bonus. Withdraw everything — capital, profits, and bonus — once conditions are met.
                </p>

                <div className="row g-2" style={{ maxWidth: "560px" }}>
                  <div className="col-4">
                    <div
                      className="p-3 text-center rounded-4 h-100 shadow-sm"
                      style={{
                        backgroundColor: "var(--bs-card-bg)",
                        border: "1px solid var(--bs-primary-border-subtle)",
                      }}
                    >
                      <div
                        className="fw-bold"
                        style={{ fontSize: "1.5rem", lineHeight: "1.2", color: "var(--bs-primary)" }}
                      >
                        {depositBonusPer}%
                      </div>
                      <div
                        className="text-uppercase fw-semibold mt-1"
                        style={{
                          fontSize: "10px",
                          color: "var(--bs-secondary-color)",
                          letterSpacing: "0.5px",
                        }}
                      >
                        BONUS ON DEPOSIT
                      </div>
                    </div>
                  </div>

                  <div className="col-4">
                    <div
                      className="p-3 text-center rounded-4 h-100 shadow-sm"
                      style={{
                        backgroundColor: "var(--bs-card-bg)",
                        border: "1px solid var(--bs-primary-border-subtle)",
                      }}
                    >
                      <div
                        className="fw-bold"
                        style={{ fontSize: "1.5rem", lineHeight: "1.2", color: "var(--bs-primary)" }}
                      >
                        ${Number(maxDepositBonus).toLocaleString()}
                      </div>
                      <div
                        className="text-uppercase fw-semibold mt-1"
                        style={{
                          fontSize: "10px",
                          color: "var(--bs-secondary-color)",
                          letterSpacing: "0.5px",
                        }}
                      >
                        MAXIMUM BONUS
                      </div>
                    </div>
                  </div>

                  <div className="col-4">
                    <div
                      className="p-3 text-center rounded-4 h-100 shadow-sm"
                      style={{
                        backgroundColor: "var(--bs-card-bg)",
                        border: "1px solid var(--bs-primary-border-subtle)",
                      }}
                    >
                      <div
                        className="fw-bold"
                        style={{ fontSize: "1.5rem", lineHeight: "1.2", color: "var(--bs-primary)" }}
                      >
                        {lotsPer100}L
                      </div>
                      <div
                        className="text-uppercase fw-semibold mt-1"
                        style={{
                          fontSize: "10px",
                          color: "var(--bs-secondary-color)",
                          letterSpacing: "0.5px",
                        }}
                      >
                        LOTS PER $100
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="px-4 py-3 d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 border-top"
                style={{
                  backgroundColor: "var(--bs-card-bg)",
                  borderColor: "var(--bs-primary-border-subtle)",
                }}
              >
                <div>
                  <div
                    className="fw-bold font-size-14"
                    style={{ color: "var(--bs-emphasis-color)" }}
                  >
                    Start earning your {depositBonusPer}% bonus today
                  </div>
                  <div
                    className="font-size-12 d-flex flex-nowrap align-items-center gap-2 mt-1 overflow-x-auto text-nowrap"
                    style={{
                      color: "var(--bs-secondary-color)",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    <span className="flex-shrink-0">✓ No time limit</span>
                    <span className="flex-shrink-0">•</span>
                    <span className="flex-shrink-0">✓ Trade any instrument</span>
                    <span className="flex-shrink-0">•</span>
                    <span className="flex-shrink-0">✓ 100% withdrawable</span>
                  </div>
                </div>

              </div>
            </div>

            <div
              className="d-flex flex-nowrap justify-content-start justify-content-md-center align-items-center gap-2 gap-sm-3 mb-4 overflow-x-auto pb-1"
              style={{
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {pillBadges.map((badge, idx) => (
                <div
                  key={idx}
                  className="d-flex align-items-center gap-2 px-3 py-2 rounded-pill shadow-sm font-size-12 fw-semibold flex-shrink-0 text-nowrap"
                  style={{
                    backgroundColor: "var(--bs-card-bg)",
                    color: "var(--bs-emphasis-color)",
                    border: "1px solid var(--bs-border-color)",
                  }}
                >
                  <i
                    className={`${badge.icon} font-size-16`}
                    style={{ color: "var(--bs-primary)" }}
                  ></i>
                  <span>{badge.label}</span>
                </div>
              ))}
            </div>

            <div className="row g-3">
              <div className="col-12 col-lg-6">
                <BonusCalculator
                  depositBonusPer={Number(depositBonusPer)}
                  maxBonus={Number(maxDepositBonus)}
                  lotsPer100={Number(lotsPer100)}
                />
              </div>
              <div className="col-12 col-lg-6">
                <HowBonus
                  depositBonusPer={Number(depositBonusPer)}
                  lotsPer100={Number(lotsPer100)}
                />
              </div>
            </div>

            <HowItWorks
              depositBonusPer={Number(depositBonusPer)}
              maxBonus={Number(maxDepositBonus)}
              lotsPer100={Number(lotsPer100)}
            />

            <BonusFaq />
          </div>
        </div>

        <Footer />
      </div>

      {/* Enroll Details Modal */}
      {/* <EnrollModal
        isOpen={showClaimModal}
        onClose={() => setShowClaimModal(false)}
        programName="Get Benifited of Bonus"
      /> */}
    </div>
  );
}
